<template>
  <div class="head-container">
    <!-- 顶部欢迎栏 -->
    <div class="header-wrap safe-wrapper">
      <div class="h-l">
        <span>Hi~欢迎加入康养合规专业委员会</span>
      </div>
    </div>

    <!-- Banner 区域 -->
    <div class="nav-banner">
      <div class="nav-banner-main safe-wrapper">
        <div class="banner-main-l">
          <span class="banner-logo">
            <img src="../assets/image/hgs-logo2.png" alt="Logo" />
          </span>
          <!-- <h1 class="banner-title">
            <span class="banner-txt">
              <span class="banner-title-text">
                养老合规师职业能力<span class="index-notice-none">（水平）</span>考试
              </span>
            </span>
            <span class="banner-title-tips">
              养老合规师考试网 <span>www.yanglao365.org.cn</span>
            </span>
          </h1> -->
          <div class="banner-main-r">
            <div class="banner-service">全国服务热线</div>
            <div class="banner-service-number">010-53670365</div>
            <div class="banner-service-tips">
              <p>中国企业评价协会</p>
              <p>康养合规专委会（主办）</p>
            </div>
          </div>
          <!-- <h1>
            <p class="banner-txt">
              全国服务热线 <span>010-53670365</span>
            </p>
            <p class="banner-title-tips">
              中国企业评价协会 康养合规专委会（主办）
            </p>
          </h1> -->
        </div>
      </div>
    </div>

    <!-- 导航菜单 -->
    <div class="nav-list">
      <div class="nav-menu-list safe-wrapper">
        <div :class="`${activeMenu == item.jump_url ? 'hover' : ''}`" v-for="(item, index) in menusList" :key="index">
          <router-link :to="`${item.jump_url == '/Home'
            ? '/Home'
            : item.jump_url + '?menu_id=' + item.id
            }`">
            {{ item.menu_name }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- 最新公告 (无缝滚动修改版) -->
    <div class="announcement-wrapper" v-if="is_show">
      <div class="announcement-content">
        <div class="announcement-content-left">
          <img src="../assets/image/icon-suona.jpg" alt="icon" />
          <span>最新公告</span>
        </div>

        <!-- 滚动容器：添加 ref 和 鼠标事件 -->
        <div class="announcement-content-right" ref="marqueeContainer" @mouseenter="stopScroll"
          @mouseleave="startScroll">
          <!-- 滚动内容：通过 style transform 控制位移 -->
          <div class="str_move" ref="marqueeContent" :style="{ transform: `translateX(${offsetX}px)` }">
            <!-- 场景1：有数据时，渲染两份列表实现无缝 -->
            <template v-if="ggtz_info.news_list && ggtz_info.news_list.length > 0">
              <!-- 第一组：原始数据 -->
              <a href="javascript:0;" v-for="(item, index) in ggtz_info.news_list" :key="'orig-' + index"
                class="notice-bar__wrap_text" @click="clickItems(item.id, ggtz_info.main_title)">
                {{ item.title }}
              </a>

              <!-- 第二组：复制数据 (用于无缝衔接) -->
              <a href="javascript:0;" v-for="(item, index) in ggtz_info.news_list" :key="'copy-' + index"
                class="notice-bar__wrap_text" @click="clickItems(item.id, ggtz_info.main_title)">
                {{ item.title }}
              </a>
            </template>

            <!-- 场景2：无数据时 -->
            <span v-else class="notice-bar__wrap_text static-text">加载中...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenus, getHome } from "../api/api";

export default {
  components: {},
  data() {
    return {
      ggtz_info: {}, // 公告通知
      menusList: [],
      is_show: true,

      // --- 新增：滚动控制变量 ---
      offsetX: 0,           // 当前位移量
      animationId: null,    // 动画帧 ID
      speed: 0.8,             // 滚动速度 (像素/帧)，数值越大越快
      isPaused: false,      // 是否暂停
      singleListWidth: 0    // 单组列表的宽度
    };
  },
  watch: {
    $route() {
      this.setCurrentRoute();
    },
    // 监听公告数据变化，数据加载完成后重新初始化滚动
    'ggtz_info.news_list': {
      handler() {
        this.$nextTick(() => {
          this.initScroll();
        });
      },
      deep: true
    }
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { path } = route;
      return "" || path;
    },
  },
  mounted() {
    // 确保 DOM 渲染完成后初始化
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  beforeDestroy() {
    // 组件销毁前清除定时器，防止内存泄漏
    this.stopScroll();
  },
  created() {
    this.setCurrentRoute();
    this.getMenus();
    this.getHome();
  },
  methods: {
    getMenus() {
      getMenus({})
        .then((res) => {
          if (res.code == 0) {
            this.menusList = res.data;
          }
        })
        .catch((e) => console.log(e));
    },
    setCurrentRoute() {
      if (this.$route.path != "/Home") {
        this.is_show = false;
      } else {
        this.is_show = true;
      }
    },
    getHome() {
      getHome({})
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.list;
            data.forEach((ele) => {
              if (ele.id == 1) {
                this.ggtz_info = ele;
                if (ele.news_list && ele.news_list.length > 0) {
                  this.ggtz_info.news_list = ele.news_list.slice(0, 5);
                } else {
                  this.ggtz_info.news_list = [];
                }
              }
            });
          }
        })
        .catch((e) => console.log(e));
    },
    clickItems(i, t) {
      this.$router.push({
        path: "/details",
        query: { id: i, title: t },
      });
    },

    // --- 核心滚动逻辑 ---

    // 初始化滚动
    initScroll() {
      this.stopScroll(); // 先清除旧的动画

      const contentEl = this.$refs.marqueeContent;
      const containerEl = this.$refs.marqueeContainer;

      if (!contentEl || !containerEl) return;

      if (!this.ggtz_info.news_list || this.ggtz_info.news_list.length === 0) {
        this.offsetX = 0; // 重置位置到最左边
        return; // 直接返回，不执行下面的 startScroll
      }

      // 计算单组列表的宽度
      // 因为我们在模板中渲染了两份数据，所以总宽度 / 2 就是单份的宽度
      const totalWidth = contentEl.offsetWidth;
      this.singleListWidth = totalWidth / 2;

      // 重置位置
      this.offsetX = 0;

      // 开始滚动
      this.startScroll();
    },

    // 开始滚动动画
    startScroll() {
      this.isPaused = false;

      const scroll = () => {
        if (!this.isPaused) {
          this.offsetX -= this.speed;

          // 核心算法：当向左移动的距离 >= 单组列表宽度时
          // 说明第一组已经完全滚出去了，第二组的开头正好接上了原位
          // 此时瞬间重置为 0，用户肉眼看不出变化，形成无限循环
          if (Math.abs(this.offsetX) >= this.singleListWidth) {
            this.offsetX = 0;
          }
        }
        // 请求下一帧动画
        this.animationId = requestAnimationFrame(scroll);
      };

      this.animationId = requestAnimationFrame(scroll);
    },

    // 停止滚动 (用于鼠标悬停)
    stopScroll() {
      this.isPaused = true;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.head-container {
  box-shadow: 0 0 6px -3px #999;
}

.safe-wrapper {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 0 1rem;
  box-sizing: border-box;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  height: 2.5rem;
}

.h-l,
.h-r {
  display: flex;
  align-items: center;
}

.h-l span {
  font-size: 0.75rem;
  color: #666;
  padding-left: 0.625rem;
}

.nav-banner {
  width: 100%;
  height: clamp(150px, 30vw, 260px);
  background: $g_bg;
  color: #fff;
  // background-image: linear-gradient(to bottom, #33adb3,#3584a7,#406393);
  background-size: 500%;
  animation: bgAnimation 15s linear infinite;
  background-image: url(../assets/image/nav-banner-new.png);
  background-size: cover;
  background-repeat: no-repeat;
}

.nav-list {
  width: 100%;
  height: 3.4375rem;
  background-color: $g_nav_bg;
  display: none;
}

.nav-banner-main {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
}

.banner-main-l {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0.5rem;
  min-width: 0;
}

.banner-main-l .banner-logo {
  // width: 16rem;
  width: clamp(14rem, 20vw, 16rem);
  height: clamp(0rem, 20vw, 3.875rem);
  // border-radius: 50%;
  margin-right: clamp(1rem, 3vw, 1.625rem);
  margin-left: clamp(-0.625rem, -2vw, -0.625rem);
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  flex-shrink: 0;
}

.banner-main-l .banner-logo img {
  width: 100%;
  height: 100%;
}

.banner-main-r {
  color: #ffffff;

  .banner-service {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 5px;
  }

  .banner-service-number {
    font-size: 17px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 5px;
  }

  .banner-service-tips {
    font-size: 10px;
    line-height: 14px;
  }
}

h1 {
  font-size: clamp(1rem, 3vw, 1.25rem);
  margin: 0;
}

.banner-main-l .banner-title {
  color: #fff;
  letter-spacing: 0.0625rem;
}

.banner-main-l .banner-title .banner-txt {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.banner-main-l .banner-title .banner-title-text {
  display: block;
  font-size: clamp(1.125rem, 4.8vw, 3.125rem);
  margin-bottom: 0.1875rem;
}

.index-notice-none {
  display: none;
}

.banner-main-l .banner-title .banner-title-tips {
  display: block;
  font-size: clamp(1.125rem, 4vw, 2.125rem);
}

.banner-main-l .banner-title .banner-title-tips span {
  display: inline-block;
  font-size: clamp(0.875rem, 3vw, 1.375rem);
}

.nav-menu-list {
  align-items: center;
  height: 100%;
  background: $g_nav_bg;

  &>div {
    flex: 1;
    height: 3.4375rem;
    line-height: 3.4375rem;
    min-width: clamp(5rem, 20vw, 7.5rem);
    font-size: clamp(0.75rem, 2.5vw, 0.875rem);
    text-align: center;
    padding: 0 0.625rem;
    color: #fff !important;
  }

  &>div>a {
    color: #fff !important;
    font-size: clamp(0.8125rem, 2.5vw, 0.9375rem);
    width: 100%;
    height: 100%;
    display: inline-block;
    text-decoration: none;
  }
}

/* --- 公告区域样式 --- */
.announcement-wrapper {
  width: 100%;
  height: 3rem;
  background: #dae9ff;
}

.announcement-wrapper .announcement-content {
  width: 100%;
  max-width: 1200px;
  height: 3rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  box-sizing: border-box;
}

.announcement-content-left {
  height: 2.125rem;
  width: clamp(5.5rem, 20vw, 6.25rem);
  background-image: url(../assets/image/suona-bg.jpg);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 0.625rem;
  flex-shrink: 0;
}

.announcement-content-left img {
  width: clamp(1rem, 3vw, 1.1875rem);
  height: clamp(0.875rem, 3vw, 1.0625rem);
  margin-right: 0.25rem;
  margin-left: 0.625rem;
}

.announcement-content-left span {
  color: #fff;
  font-size: clamp(0.75rem, 2.5vw, 0.8125rem);
}

.announcement-content-right {
  flex: 1;
  background: #dae9ff;
  overflow: hidden;
  /* 关键：隐藏超出部分 */
  position: relative;
  white-space: nowrap;
  /* 关键：强制不换行 */
  display: flex;
  align-items: center;
  cursor: pointer;
}

.str_move {
  display: inline-block;
  white-space: nowrap;
  will-change: transform;
  /* 性能优化：启用 GPU 加速 */
  /* 注意：这里移除了原有的 animation 属性，改由 JS 控制 transform */
}

.notice-bar__wrap_text {
  font-size: clamp(0.75rem, 2.5vw, 0.875rem);
  font-weight: 500;
  color: $g_color;
  line-height: 3rem;
  padding-right: clamp(1.875rem, 5vw, 3.75rem);
  text-decoration: none;
  display: inline-block;
}

.static-text {
  font-size: clamp(0.75rem, 2.5vw, 0.875rem);
  font-weight: 500;
  color: $g_color;
  padding-right: 0;
  /* 去掉右侧间距 */
  cursor: default;
  /* 鼠标变为默认形状，不可点击 */
}

.separator {
  opacity: 0.5;
  user-select: none;
  margin-left: 5px;
}

/* 平板及以上设备显示导航菜单 */
@media screen and (min-width: 768px) {
  .nav-list {
    display: block;
  }

  .banner-main-l .banner-logo {
    // width: clamp(7.25rem, 20vw, 11.875rem);
    width: clamp(46rem, 20vw, 100rem);
    height: clamp(7.25rem, 20vw, 12rem);
    // border-radius: 50%;
    margin-right: clamp(1rem, 3vw, 1.625rem);
    margin-left: clamp(-0.625rem, -2vw, -0.625rem);
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    flex-shrink: 0;
  }

  .banner-main-l .banner-logo img {
    width: 100%;
    height: 100%;
  }

  .banner-main-r {
    color: #ffffff;
    margin-top: 16px;

    .banner-service {
      font-size: 22px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .banner-service-number {
      font-size: 38px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 12px;
    }

    .banner-service-tips {
      font-size: 16px;
      font-weight: 400;
      line-height: 30px;
    }
  }


  .nav-banner {
    background-image: url(../assets/image/nav-banner-new.png);
    background-size: cover, cover;
    background-position: center, center;
  }

  .nav-menu-list {
    display: flex;
    align-items: center;
    height: 100%;
    background: $g_nav_bg;

    &>div {
      flex: 1;
      height: 55px;
      line-height: 55px;
      min-width: 120px;
      font-size: 14px;
      text-align: center;
      padding: 0 10px;
      color: #fff !important;
    }

    &>div>a {
      color: #fff !important;
      font-size: 15px;
      width: 100%;
      height: 100%;
      display: inline-block;
    }

    &>div.hover,
    &>div:hover {
      background-color: $g_nav_active_bg !important;
      border-bottom: none !important;
    }
  }

  .banner-main-l .banner-title .banner-title-text {
    display: block;
    font-size: clamp(1.125rem, 5vw, 3.125rem);
    margin-bottom: 0.1875rem;
  }

  .index-notice-none {
    display: inline-block;
  }

  /* 移除原有的 CSS keyframes move，避免与 JS 冲突 */
}

/* 大屏设备优化 */
@media screen and (min-width: 1200px) {
  .safe-wrapper {
    padding: 0;
  }

  .announcement-wrapper .announcement-content {
    padding: 0;
  }
}
</style>